import React from "react";
import { Button, Grid, Card } from "@material-ui/core";
import iconLogo from "../../../../img/logoFull.png";

export default function Confirmed({
  AgreementNumber,
  GetCertificate,
  CertificateButton,
}) {
  return (
    <Card className="c-agc-card" elevation={3}>
      <Grid className="c-agc-card-header" container>
        <Grid item xs={12} md={12}>
          <h4>Contratación Realizada</h4>
        </Grid>
      </Grid>
      <Grid className="c-agc-card-body" container>
        <Grid className="c-agc-card-body-confirmed" item xs={12} md={12}>
          <Grid className="c-agc-card-body-confirmed-title" container>
            <Grid item xs={12} md={12}>
              <h3>¡Listo!</h3>
            </Grid>
          </Grid>
          <img className="img" src={iconLogo} />
          <Grid className="c-agc-card-body-confirmed-message" container>
            <Grid item xs={12} md={12}>
              <p>
                Se ha realizado con éxito la contratación
                <br /> del servicio de asistencia bajo el número de Multiasistencia{" "}
                {AgreementNumber}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}
